// extracted by mini-css-extract-plugin
export var statItem = "_i8-1";
export var statsRow = "_i8-0";